import React, { useState } from 'react';

const useObjectState = (defaultState = null, options = {}) => {
  const [object, setObject] = useState(defaultState);
  const clear = React.useCallback(() => {
    setObject(null);
  }, [
    setObject
  ]);
  const { onSet } = options;
  const set = React.useCallback((object2) => {
    setObject(object2);
    void onSet?.({
      value: object2,
      clear
    });
  }, [
    onSet,
    clear
  ]);
  const state = React.useMemo(() => {
    return {
      value: object,
      clear,
      set
    };
  }, [
    object,
    clear,
    set
  ]);
  return state;
};

export { useObjectState };
//# sourceMappingURL=useObjectState.js.map
